export class HoverDef extends HTMLElement
{
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.initEventListeners();
     }

    initEventListeners() {
        // whcn clicked, go to the official aam definition if it exists.
        // it exists in the tooltip template found by the data-title attribute, which should match the term_id of a definition template.
        this.addEventListener('click', (event) => {
            const slug = this.getAttribute('slug');
            const tooltipTemplate = document.querySelector(`tooltip-templates template[data-term_id="${slug}"]`);
            if (tooltipTemplate) {
                const definitionAnchor = tooltipTemplate.dataset.definition_anchor;
                if (definitionAnchor) {
                    // close tooltip if open
                    const definitionTooltip = this.querySelector('definition-tooltip');
                    if (definitionTooltip) {
                        definitionTooltip.hideTooltip();
                    }
                    const url = new URL(definitionAnchor, window.location.origin);
                    if (url.pathname === window.location.pathname) {
                        // Same page — scroll directly to the anchor
                        const el = document.getElementById(url.hash.slice(1));
                        if (el) {
                            history.pushState(null, '', url.hash);
                            el.scrollIntoView({ behavior: 'smooth' });
                        } else {
                            window.location.href = definitionAnchor; // fallback to normal navigation if element not found
                        }
                    } else {
                        window.location.href = definitionAnchor;
                    }
                }
            }
        });
    }


}

customElements.define("hover-def", HoverDef);

